import Column from "@components/column";
import React from "react";
import BrandForm from "./form";
import BrandList from "./list";

const BrandSetup = () => {
  return (
    <Column>
      <BrandForm />
      <BrandList />
    </Column>
  );
};

export default BrandSetup;
